export const sort = {
  toggleDetails: 'Sort',
  sortBy: 'Sort by',
  name: {
    asc: 'name, ascending',
    desc: 'name, descending',
  },
  price: {
    asc: 'price, ascending',
    desc: 'price, descending',
  },
  relevance: 'relevance',
  recommended: 'recommended for you',
};

export const country = {
  AT: 'Austria',
};

export const status = {
  loggedIn: 'Log out',
  loggedOut: 'Log in',
  cancel: 'Cancel',
  select: 'Please select',
  save: 'Save',
  edit: 'Edit',
  add: 'Add new address',
  delete: 'Delete',
  loading: 'Loading',
  yes: 'Yes',
  optional: 'optional',
  rename: 'Rename',
  back: 'Back',
  toShop: 'Continue to online shop',
  accept: 'Accept',
};

export const missing = {
  image: 'No image.',
};
